import React, { Component } from "react";
import classNames from "classnames";

import StoryHeader from "../StoryHeader";
import StoryContent from "../StoryContent";
import StoryFooter from "../StoryFooter";

import styles from "./StoryCard.css";

class StoryCard extends Component {

  render() {
    const { story, hideHeader, hideFooter, header } = this.props;
    if (!story) return null;
    return (
      <div
        id={story.id}
        className={classNames(
          "story-card",
          styles.root,
          this.props.className,
          story.slideIn ? styles.slideIn : {},
          story.is_featured && styles.featured)}>
        <div className={classNames("permalink", styles.hide)}>{story.permalink}</div>
        {!hideHeader && (header || <StoryHeader story={story}/>)}
        <StoryContent story={story}/>
        {!hideFooter && <StoryFooter story={story}/>}
      </div>
    );
  }
}

export default StoryCard;



// WEBPACK FOOTER //
// ./src/components/Library/StoryCard/StoryCard.js